{
  "headings": {
    "question": "Fråga om boende",
    "housingQuestion": "Boenderelaterad fråga",
    "questionPreview": "Förhandsvisning av fråga",
    "questionDetail": "Frågedetaljer",
    "preview": "Förhandsvisning",
    "success": "Fråga"
  },
  "texts": {
    "instructions": "Behöver du hjälp med boenderelaterade frågor?\n\nSkicka ett meddelande till oss via formuläret nedan - vi kontaktar dig så snart som möjligt.\n\nVid brådskande ärenden ber vi dig kontakta våra experter via sidan Kontaktuppgifter.",
    "success": "Din fråga har skickats. Vi kommer att svara på den via e-post.",
    "expectsResponseInstructions": "Vill du ha ett svar på din feedback? Om du önskar få ett svar, vänligen nämn det i ditt meddelande. På så sätt kan vi säkerställa att vi återkommer till dig så smidigt som möjligt.",
    "contactDetailsUpdateInstructions": "Om det behövs kan du uppdatera dina kontaktuppgifter här. Du kan också redigera dem via sidan Mina uppgifter."
  },
  "placeholders": {
    "title": "Titel",
    "description": "Beskriv din fråga mer detaljerat"
  },
  "alt": {
    "successIllustration": "Tack illustration"
  },
  "labels": {
    "title": "Titel",
    "description": "Beskrivning",
    "files": "Bilagor",
    "email": "E-post",
    "phoneNumber": "Telefon",
    "expectsResponse": "Jag vill bli kontaktad"
  },
  "actions": {
    "back": "Tillbaka",
    "resetForm": "Rensa formulär",
    "sendForm": "Skicka fråga",
    "preview": "Förhandsgranska",
    "edit": "Redigera",
    "submit": "Skicka"
  },
  "errors": {
    "submitError": "Fel vid skickande av frågan. Om problemet kvarstår, kontakta kundservice.",
    "serviceUnavailable": "Frågeskapande är inte tillgängligt för tillfället. Försök igen senare.",
    "noQuestionFound": "Ingen fråga hittades.",
    "missingUserPhoneNumber": {
      "title": "Tyvärr gick det inte att skapa frågan",
      "message": "För att kunna fortsätta med din fråga, lägg till ditt telefonnummer i din profil."
    }
  }
}
